module.exports = __webpack_public_path__ + "static/old-wives-ale-2321e673c7746bb8116241db5836d072.jpg";